import { render, staticRenderFns } from "./BaseDurationPicker.vue?vue&type=template&id=359f0310&scoped=true"
import script from "./BaseDurationPicker.vue?vue&type=script&lang=js"
export * from "./BaseDurationPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359f0310",
  null
  
)

export default component.exports